<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h2`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm33.304 10.444c2.264.024 4.1.747 5.51 2.168 1.433 1.41 2.162 3.198 2.186 5.366 0 1.734-.53 3.276-1.59 4.625l-8.473 10.623H45a1 1 0 011 1v1.776a1 1 0 01-1 1H31.987a1 1 0 01-1-1v-2.209a1 1 0 01.219-.624l10.06-12.59c.398-.517.67-1 .814-1.445.096-.421.144-.819.144-1.192 0-.988-.307-1.849-.921-2.584-.639-.734-1.542-1.114-2.71-1.138-1.036 0-1.897.331-2.584.994-.556.519-.936 1.204-1.138 2.055l-.055.26a.594.594 0 01-.584.485h-2.716a.494.494 0 01-.494-.494l.002-.046c.186-1.952.908-3.584 2.167-4.898 1.385-1.397 3.09-2.108 5.113-2.132z"/></svg>
</template>
<script>

export default {
  name: 'IconH2',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
